import {
  LayoutDashboard, ShoppingCart, Store, Users, Truck, Receipt, BarChart3,
  Shield, CreditCard, FileText, Tags, UserCheck, FileWarning, Bell,
  User as UserIcon, Settings, ArrowLeftRight, FileInput, AlertTriangle,
  Handshake, HelpCircle, Building2, Package, ChefHat, CalendarClock,
  ArrowDownUp, Activity, PackageCheck, Zap,
  AlertCircle, Moon, Sun, Keyboard, Globe, UtensilsCrossed, Camera, Armchair, Wallet,
  CalendarDays, Gift, TrendingUp, Clock, Database, Copy, Download, ShieldCheck, Award, Crown, Paintbrush, Key, Layers, GraduationCap, FileCheck, Target, ClipboardCheck, Briefcase, BarChart2, Scissors, Scale, Beef, Ruler, Pill, CakeSlice, Cpu, DollarSign, Brain, Gauge, Banknote, BookOpen, GitCompare, Repeat, Factory, Wrench, TestTubes, Boxes, Eye, Megaphone, ClipboardList, PieChart, HandCoins, Wand2, Inbox, Sparkles, CalendarCheck2, Printer, ScanLine, QrCode,
} from 'lucide-react';

// Sidebar item descriptions for tooltips
export const NAV_DESCRIPTIONS = {
  '/': 'Overview of your business metrics and key performance indicators',
  '/daily-summary': 'Quick snapshot of today\'s sales, expenses, and activities',
  '/pos': 'Fast point-of-sale entry for recording sales transactions',
  '/pos-analytics': 'Real-time analytics and live performance monitoring',
  '/sales': 'View and manage all sales records across branches',
  '/platforms': 'Manage online delivery platforms and their commissions',
  '/invoices': 'Create and manage customer invoices with payment tracking',
  '/proforma-invoices': 'Create pre-sale quotation documents before finalizing invoices',
  '/debit-notes': 'Issue additional charges or adjustments to customer accounts',
  '/credit-notes': 'Issue refunds or credits against customer invoices',
  '/customer-receipts': 'Record and track payments received from customers',
  '/sales-transactions': 'View all sales documents in one consolidated transaction list',
  '/order-tracking': 'Track order status from placement to delivery',
  '/customers': 'Customer database with credit tracking and history',
  '/loyalty': 'Set up and manage customer loyalty reward programs',
  '/expenses': 'Record and categorize all business expenses',
  '/bills': 'Manage vendor bills and payment schedules',
  '/bill-returns': 'Process returns of goods to suppliers and record adjustments',
  '/account-statement': 'Transaction history for a specific account',
  '/account-summary': 'Overview of all accounts with debit/credit balances',
  '/cost-center-report': 'Expenses grouped by branch/cost center',
  '/sales-vat-report': 'VAT collected on sales transactions',
  '/purchases-vat-report': 'VAT paid on purchases and bills',
  '/sales-summary-report': 'Aggregated sales by branch and payment mode',
  '/purchases-summary-report': 'Aggregated purchases by category and supplier',
  '/supplier-receipts-page': 'Record payment confirmations made to suppliers',
  '/purchase-transactions': 'View all purchase documents in one consolidated transaction list',
  '/suppliers': 'Supplier database with contact info and payment terms',
  '/supplier-payments': 'Track and record payments made to suppliers',
  '/supplier-aging': 'Aging analysis of outstanding supplier payments',
  '/supplier-reminders': 'Automated payment reminders for due supplier invoices',
  '/cash-transfers': 'Move money (cash or bank) between branches, office and accounts',
  '/employees': 'Employee database with profiles, roles, and documents',
  '/attendance-dashboard': 'Track employee attendance, check-ins, and absences',
  '/payroll': 'Process employee salaries, deductions, and payslips',
  '/loans': 'Manage employee loan requests and repayment tracking',
  '/leave-approvals': 'Review and approve employee leave requests',
  '/leave-calendar': 'Visual calendar of all employee leaves and availability',
  '/employee-documents': 'Store and manage employee documents',
  '/performance-reviews': 'Conduct performance reviews and set employee goals',
  '/training': 'Track employee training programs and certifications',
  '/recruitment': 'Manage job postings, applications, and hiring',
  '/hr-analytics': 'HR metrics: headcount, turnover, attendance trends',
  '/org-chart': 'Visual organization chart showing team hierarchy',
  '/schedule': 'Create and manage employee shift schedules',
  '/staff-performance': 'Employee reliability scores based on attendance and tasks',
  '/country-laws': 'Reference guide for local labor laws and regulations',
  '/stock': 'Manage inventory items, stock levels, and auto-reorder alerts',
  '/stock-reorder': 'AI-powered stock reorder suggestions based on trends',
  '/inventory-forecast': 'AI demand forecasting for inventory planning',
  '/transfers': 'Move stock/goods (not money) between branches and warehouses',
  '/recipes': 'Define recipes with ingredients and production costs',
  '/procurement': 'Smart procurement suggestions based on stock levels',
  '/menu-items': 'Manage menu items with prices, images, and modifiers',
  '/branch-price-management': 'Set per-branch custom prices for any menu item — updates the Z-report totals automatically',
  '/addons': 'Create reusable add-on items for menu customization',
  '/menu-analytics': 'Analyze menu performance, top sellers, and margins',
  '/table-management': 'Manage restaurant tables and seating layout',
  '/reservations': 'Handle customer reservations and table bookings',
  '/salon-appointments': 'Book and manage salon/spa appointments',
  '/kitchen': 'Kitchen display for incoming orders and preparation',
  '/pos-config': 'Configure POS settings, receipt format, and payments',
  '/financial-dashboard': 'High-level financial overview with key ratios',
  '/chart-of-accounts': 'Define your accounting chart of accounts structure',
  '/category-account-mapping': 'Route expense categories to specific accounts for Journal Entries',
  '/multi-branch-pnl-matrix': 'Pivot P&L report — branches as columns, line items as rows, with margin %',
  '/journal-entries': 'Create and manage manual journal entries',
  '/profit-loss': 'Profit & Loss statement for any date range',
  '/balance-sheet': 'Balance sheet showing assets, liabilities, and equity',
  '/cash-flow': 'Cash flow statement tracking money in and out',
  '/general-ledger': 'Complete ledger of all accounting transactions',
  '/quotations': 'Create price quotes for customers. Approve, send, and convert to sales',
  '/purchase-orders': 'Create and track purchase orders to suppliers',
  '/analytics': 'Business analytics dashboards and trend analysis',
  '/reports': 'Generate standard business reports',
  '/branches': 'Manage business branches, locations, and settings',
  '/users': 'Manage system users, roles, and permissions',
  '/settings': 'System-wide settings and configurations',
  '/factory-dashboard': 'Factory overview with production metrics',
  '/production-orders': 'Create and manage manufacturing production orders',
  '/bill-of-materials': 'Define product BOMs with components and quantities',
  '/raw-materials': 'Track raw material inventory and suppliers',
  '/machines': 'Manage factory machines, maintenance, and schedules',
  '/quality-control': 'Quality inspection records and compliance tracking',
  '/factory-analytics': 'Production analytics, efficiency, and output trends',
  '/announcements': 'Create and broadcast company-wide announcements',
  '/surveys': 'Create employee surveys and collect feedback',
  '/visitors': 'Log and track visitor check-ins and purposes',
  '/fleet': 'Manage company vehicles, drivers, and maintenance',
  '/budget': 'Set budgets and compare actual vs planned spending',
  '/branch-cost-analyzer': 'Auto-calculate per-branch costs, revenue, and profitability analysis',
};

export const NAV_GROUPS = [
  // Top-level: Dashboard always visible, single-item group renders flat.
  {
    label: 'Dashboard', singleItem: true,
    items: [
      { path: '/', icon: LayoutDashboard, label: 'Dashboard', perm: 'dashboard', roles: ['admin', 'manager'] },
    ]
  },
  // iter893 — Six-section flat hierarchy. The old 17-group sidebar was
  // consolidated per operator request ("group the 40+ nav links into 6
  // collapsible parent sections") so busy cashiers/managers find what
  // they need without endless scrolling. Order matches the request:
  // iter931 — Granular hierarchy per user request:
  //   1. Operations and POS   2. Daily Operations   3. Supply Chain
  //   4. Finance & Banking    5. VAT & Compliance   6. HR & Payroll   7. Settings
  {
    label: 'Operations and POS', module: 'pos', defaultOpen: true,
    // iter930 — Flat top-level items are the daily-driver POS surfaces.
    // Specialised areas (Menu, Factory, Reservations) live in
    // sub-folders below so operators aren't overwhelmed on load.
    items: [
      { path: '/daily-summary', icon: CalendarDays, label: 'Daily Summary' },
      { path: '/pos', icon: ShoppingCart, label: 'Quick Entry (POS)', perm: 'sales' },
      { path: '/orders/live', icon: Activity, label: 'Live Orders', perm: 'sales', newSince: '2026-07-19' },
      { path: '/kitchen', icon: ChefHat, label: 'Kitchen', perm: 'kitchen' },
      { path: '/stock', icon: Package, label: 'Stock Items', perm: 'stock', roles: ['admin', 'manager'] },
    ],
    subgroups: [
      {
        label: 'POS Analytics',
        items: [
          { path: '/pos-analytics', icon: Activity, label: 'POS Analytics', perm: 'sales', roles: ['admin', 'manager'] },
          { path: '/drawer-audit', icon: Wallet, label: 'Drawer Audit', perm: 'sales', roles: ['admin', 'manager'], newSince: '2026-06-30' },
          { path: '/order-tracking', icon: Truck, label: 'Order Tracking', perm: 'sales', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Tables & Reservations',
        items: [
          { path: '/table-management', icon: Armchair, label: 'Tables', perm: 'stock', roles: ['admin', 'manager'] },
          { path: '/reservations', icon: CalendarDays, label: 'Reservations', perm: 'stock', roles: ['admin', 'manager'] },
          { path: '/salon-appointments', icon: Scissors, label: 'Appointments', perm: 'stock', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Stock Operations',
        items: [
          { path: '/transfers', icon: PackageCheck, label: 'Stock Transfers', perm: 'stock', roles: ['admin', 'manager'] },
          { path: '/stock-reorder', icon: ShoppingCart, label: 'Reorder Suggestions', perm: 'stock', roles: ['admin', 'manager'] },
          { path: '/inventory-forecast', icon: TrendingUp, label: 'Demand Forecast', perm: 'stock', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Menu & Pricing',
        items: [
          { path: '/recipes', icon: ChefHat, label: 'Recipes', perm: 'stock', roles: ['admin', 'manager', 'operator'] },
          { path: '/menu-items', icon: UtensilsCrossed, label: 'Menu Items', perm: 'stock', roles: ['admin', 'manager'] },
          { path: '/branch-price-management', icon: DollarSign, label: 'Branch Prices', perm: 'stock', roles: ['admin', 'manager'] },
          { path: '/addons', icon: Package, label: 'Add-ons', perm: 'stock', roles: ['admin', 'manager'] },
          { path: '/menu-analytics', icon: BarChart3, label: 'Menu Analytics', perm: 'stock', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Factory',
        items: [
          { path: '/factory-dashboard', icon: Factory, label: 'Factory Dashboard', perm: 'factory' },
          { path: '/production-orders', icon: ClipboardCheck, label: 'Production Orders', perm: 'factory' },
          { path: '/bill-of-materials', icon: FileText, label: 'Bill of Materials', perm: 'factory' },
          { path: '/raw-materials', icon: Boxes, label: 'Raw Materials', perm: 'factory' },
          { path: '/machines', icon: Wrench, label: 'Machines & Equipment', perm: 'factory' },
          { path: '/quality-control', icon: TestTubes, label: 'Quality Control', perm: 'factory' },
        ],
      },
    ],
  },
  {
    label: 'Daily Operations', module: 'sales',
    // iter931 — User-requested grouping: POS, Sales, Invoices, Quotations
    // stay flat; everything else moved into sub-groups.
    items: [
      { path: '/pos', icon: ShoppingCart, label: 'POS', perm: 'sales' },
      { path: '/sales', icon: ShoppingCart, label: 'Sales', perm: 'sales' },
      { path: '/invoices', icon: FileInput, label: 'Invoices', perm: 'invoices' },
      { path: '/quotations', icon: FileText, label: 'Quotations', perm: 'invoices', roles: ['admin', 'manager'] },
    ],
    subgroups: [
      {
        label: 'Customers & Loyalty',
        items: [
          { path: '/customers', icon: Users, label: 'Customers', perm: 'customers' },
          { path: '/loyalty', icon: Gift, label: 'Loyalty Program', perm: 'customers' },
          { path: '/platforms', icon: Truck, label: 'Online Platforms', perm: 'sales' },
        ],
      },
      {
        label: 'Documents & Notes',
        items: [
          { path: '/proforma-invoices', icon: FileText, label: 'Proforma Invoices', perm: 'invoices' },
          { path: '/customer-receipts', icon: Receipt, label: 'Customer Receipts', perm: 'sales' },
          { path: '/credit-notes', icon: FileText, label: 'Credit Notes', perm: 'invoices' },
          { path: '/debit-notes', icon: FileText, label: 'Debit Notes', perm: 'invoices' },
        ],
      },
      {
        label: 'Sales Reports',
        items: [
          { path: '/sales-transactions', icon: BarChart3, label: 'Sales Transactions', perm: 'invoices' },
          { path: '/sales-summary-report', icon: BarChart3, label: 'Sales Reports', perm: 'reports', roles: ['admin', 'manager'] },
        ],
      },
    ],
  },
  {
    label: 'Supply Chain', module: 'expenses',
    // iter931 — User-requested grouping: Purchases, Bills, Suppliers flat.
    items: [
      { path: '/purchase-orders', icon: ShoppingCart, label: 'Purchase Orders', perm: 'expenses', roles: ['admin', 'manager'] },
      { path: '/bills', icon: FileText, label: 'Bills', perm: 'expenses', roles: ['admin', 'manager'] },
      { path: '/suppliers', icon: Truck, label: 'Suppliers', perm: 'suppliers', roles: ['admin', 'manager'] },
      { path: '/scan-invoice', icon: ScanLine, label: 'Scan Invoice QR', perm: 'expenses', roles: ['admin', 'manager'], newSince: '2026-06-22' },
    ],
    subgroups: [
      {
        label: 'Payments & Receipts',
        items: [
          { path: '/supplier-payments', icon: Receipt, label: 'Supplier Payments', perm: 'supplier_payments', roles: ['admin', 'manager'] },
          { path: '/supplier-receipts-page', icon: Receipt, label: 'Supplier Receipts', perm: 'expenses', roles: ['admin', 'manager'] },
          { path: '/supplier-reminders', icon: Bell, label: 'Payment Reminders', perm: 'suppliers', roles: ['admin', 'manager'] },
          { path: '/bill-returns', icon: FileText, label: 'Bill Returns', perm: 'expenses', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Procurement',
        items: [
          { path: '/procurement', icon: ShoppingCart, label: 'Procurement', perm: 'stock', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Purchase Reports',
        items: [
          { path: '/purchase-transactions', icon: BarChart3, label: 'Purchase Transactions', perm: 'expenses', roles: ['admin', 'manager'] },
          { path: '/purchases-summary-report', icon: BarChart3, label: 'Purchase Reports', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/supplier-spent', icon: BarChart3, label: 'Supplier Spend', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/supplier-aging', icon: Clock, label: 'Supplier Aging', perm: 'reports', roles: ['admin', 'manager'] },
        ],
      },
    ],
  },
  {
    label: 'Finance & Banking', module: 'accounting',
    // iter930 — Curated flat items are the "everyday accountant"
    // shortcuts: Chart of Accounts, Journal Entries, VAT tracker,
    // and headline P&L / Balance Sheet. Everything else is grouped
    // into semantic sub-folders (Banking, Reconciliation, Reports,
    // Advanced Analytics) so the 49-item wall doesn't overwhelm
    // operators anymore.
    items: [
      { path: '/reconciliation-center', icon: Inbox, label: 'Banking Reconciliation Inbox', perm: 'reports', roles: ['admin', 'manager'], newSince: '2026-06-30' },
      { path: '/chart-of-accounts', icon: Tags, label: 'Chart of Accounts', perm: 'reports', roles: ['admin', 'manager'] },
      { path: '/journal-entries', icon: FileText, label: 'Journal Entries', perm: 'reports', roles: ['admin', 'manager'] },
      { path: '/expenses', icon: Receipt, label: 'Expenses', perm: 'expenses' },
      { path: '/profit-loss', icon: TrendingUp, label: 'Profit & Loss', perm: 'reports', roles: ['admin', 'manager'] },
      { path: '/balance-sheet', icon: Scale, label: 'Balance Sheet', perm: 'reports', roles: ['admin', 'manager'] },
    ],
    subgroups: [
      {
        label: 'Ledger & Journals',
        items: [
          { path: '/auto-journal', icon: Zap, label: 'Auto-Journal Rules', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/recurring-entries', icon: Repeat, label: 'Recurring Entries', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/category-account-mapping', icon: Tags, label: 'Category Mapping', perm: 'settings', roles: ['admin', 'manager'] },
          { path: '/general-ledger', icon: BookOpen, label: 'General Ledger', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/trial-balance', icon: BookOpen, label: 'Trial Balance', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/reversals-report', icon: Repeat, label: 'Reversals', perm: 'reports', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Budgets & Planning',
        items: [
          { path: '/budget', icon: Target, label: 'Budgets', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/budget-vs-actual', icon: BarChart3, label: 'Budget vs Actual', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/cost-center-report', icon: PieChart, label: 'Cost Centers', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/fines', icon: AlertTriangle, label: 'Fines & Penalties', perm: 'fines', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Banking',
        items: [
          { path: '/bank-accounts', icon: Building2, label: 'Bank Accounts', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/banking-rules', icon: Wand2, label: 'Auto-Rules', perm: 'expenses', roles: ['admin', 'manager'], newSince: '2026-04-29' },
          { path: '/bank-statements', icon: FileText, label: 'Bank Statements', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/platforms', icon: Truck, label: 'Platform Masters', perm: 'sales', roles: ['admin', 'manager'] },
        ],
      },
      {
        // iter — Banking reconciliation consolidated into the single
        // "Banking Reconciliation Inbox" (flat item above). The legacy
        // advanced recon pages remain reachable by direct URL (routes +
        // code intact) but are hidden from the sidebar to remove the
        // overlapping-page confusion. Reuses all existing recon engines.
        label: 'Reconciliation (Advanced)',
        hidden: true,
        items: [
          { path: '/recon-cockpit', icon: Gauge, label: 'Recon Cockpit', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/bank-statements/reconcile', icon: Sparkles, label: 'Reconciliation Cockpit', perm: 'bank_statements', roles: ['admin', 'manager'] },
          { path: '/smart-reconciliation', icon: Scale, label: 'Smart Reconciliation', perm: 'bank_statements', roles: ['admin', 'manager'] },
          { path: '/bank-reconciliation', icon: GitCompare, label: 'Bank Reconciliation', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/reconciliation-inbox', icon: Inbox, label: 'Reconciliation Inbox (legacy)', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/banking-hub', icon: Banknote, label: 'Banking Hub', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/banking-quick-link', icon: Inbox, label: 'Quick-link Inbox', perm: 'expenses', roles: ['admin', 'manager'] },
          { path: '/monthly-reconciliation', icon: CalendarCheck2, label: 'Monthly Tracker', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/recon-inbox', icon: Inbox, label: 'Pending Inbox', perm: 'reports', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Transfers & Advances',
        items: [
          { path: '/cash-transfers', icon: ArrowLeftRight, label: 'Money Transfers (Cash / Bank)', perm: 'cash_transfers', roles: ['admin', 'manager'] },
          // Beneficiaries screen hidden (owner decision 2026-11-02): matching reuses Supplier/Customer/Employee/Partner; data + /beneficiaries route kept
          { path: '/pass-through-advances', icon: HandCoins, label: 'Pass-Through Advances', perm: 'expenses', roles: ['admin', 'manager'], newSince: '2026-04-28' },
          { path: '/inter-branch-ledger', icon: GitCompare, label: 'Inter-Branch Ledger', perm: 'reports', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Financial Reports',
        items: [
          { path: '/cash-flow', icon: ArrowDownUp, label: 'Cash Flow', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/aging-reports', icon: Clock, label: 'Aging Reports', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/account-statement', icon: FileText, label: 'Account Statement', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/account-summary', icon: BarChart3, label: 'Account Summary', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/accounting-reports', icon: BarChart3, label: 'All Reports', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/accounting/audit-timeline', icon: BookOpen, label: 'Month-End Audit', perm: 'accounting', roles: ['admin', 'manager'], newSince: '2026-05-24' },
          { path: '/accounting/cancelled-transactions', icon: BookOpen, label: 'Cancelled Transactions', perm: 'accounting', roles: ['admin', 'manager'], newSince: '2026-10-14' },
          { path: '/year-end-closing', icon: CalendarDays, label: 'Year-End Closing', perm: 'reports', roles: ['admin'] },
          { path: '/export-center', icon: Download, label: 'Export Center', perm: 'reports', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Analytics & Insights',
        items: [
          { path: '/financial-dashboard', icon: PieChart, label: 'Financial Dashboard', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/financial-ratios', icon: BarChart3, label: 'Financial Ratios', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/multi-branch-pnl-matrix', icon: BarChart2, label: 'Multi-Branch P&L', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/branch-cost-analyzer', icon: PieChart, label: 'Branch Cost Analyzer', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/pnl-compare', icon: GitCompare, label: 'P&L Comparison', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/smart-dunning', icon: AlertCircle, label: 'Smart Dunning', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/ai-branch-loss', icon: Brain, label: 'AI Loss Insights', perm: 'reports', roles: ['admin', 'manager'] },
        ],
      },
    ],
  },
  {
    label: 'VAT & Compliance', module: 'accounting',
    // iter931 — User-requested grouping: every VAT, ZATCA and HMRC surface
    // in ONE place (moved from Finance and Setup).
    items: [
      { path: '/vat-tracker', icon: CalendarClock, label: 'VAT Filing Tracker', perm: 'reports', roles: ['admin', 'manager'], newSince: '2026-02-15' },
      { path: '/vat-summary', icon: Scale, label: 'VAT Summary (Monthly)', perm: 'reports', roles: ['admin', 'manager'] },
      { path: '/zatca-phase2', icon: ShieldCheck, label: 'ZATCA', perm: 'reports', roles: ['admin'], country: ['sa'] },
    ],
    subgroups: [
      {
        label: 'VAT Reports & Filing',
        items: [
          { path: '/sales-vat-report', icon: FileText, label: 'Sales VAT Report', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/purchases-vat-report', icon: FileText, label: 'Purchase VAT Report', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/tax-submissions', icon: FileCheck, label: 'VAT Submissions', perm: 'reports', roles: ['admin'] },
          { path: '/tax-settings', icon: Receipt, label: 'VAT Settings', perm: 'reports', roles: ['admin'] },
        ],
      },
      {
        label: 'Compliance',
        items: [
          { path: '/receipt-verify', icon: ShieldCheck, label: 'Receipt Verify', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/hmrc-mtd', icon: ShieldCheck, label: 'HMRC MTD', perm: 'reports', roles: ['admin'], country: ['gb', 'uk'] },
          { path: '/compliance', icon: ShieldCheck, label: 'Compliance', perm: 'reports', roles: ['admin'] },
          { path: '/wht', icon: Receipt, label: 'WHT', perm: 'reports', roles: ['admin'] },
        ],
      },
    ],
  },
  {
    label: 'HR & Payroll', module: 'hr',
    // iter930 — Sub-folders for the 19-item People group so the most
    // common HR flows (Employees + Payroll + Attendance) stay flat.
    items: [
      { path: '/employees', icon: UserCheck, label: 'Employees', perm: 'employees', roles: ['admin', 'manager'] },
      { path: '/payroll', icon: CreditCard, label: 'Payroll', perm: 'employees', roles: ['admin', 'manager'] },
      { path: '/attendance-dashboard', icon: ClipboardCheck, label: 'Attendance', perm: 'employees', roles: ['admin', 'manager'] },
      { path: '/schedule', icon: CalendarClock, label: 'Schedule', perm: 'shifts', roles: ['admin', 'manager'] },
    ],
    subgroups: [
      {
        label: 'Compensation',
        items: [
          { path: '/salary-report', icon: Wallet, label: 'Salary Report', perm: 'employees', roles: ['admin', 'manager'] },
          { path: '/loans', icon: Wallet, label: 'Loans', perm: 'employees', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Leave & Absence',
        items: [
          { path: '/leave-approvals', icon: Bell, label: 'Leave Approvals', perm: 'employees', roles: ['admin', 'manager'] },
          { path: '/leave-calendar', icon: CalendarDays, label: 'Leave Calendar', perm: 'employees', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Records & Development',
        items: [
          { path: '/employee-documents', icon: FileCheck, label: 'Documents', perm: 'employees', roles: ['admin', 'manager'] },
          { path: '/performance-reviews', icon: Target, label: 'Performance', perm: 'employees', roles: ['admin', 'manager'] },
          { path: '/training', icon: GraduationCap, label: 'Training', perm: 'employees', roles: ['admin', 'manager'] },
          { path: '/recruitment', icon: Briefcase, label: 'Recruitment', perm: 'employees', roles: ['admin', 'manager'] },
          { path: '/org-chart', icon: Users, label: 'Org Chart', perm: 'employees', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Analytics & Compliance',
        items: [
          { path: '/hr-analytics', icon: BarChart3, label: 'HR Analytics', perm: 'employees', roles: ['admin', 'manager'] },
          { path: '/staff-food-report', icon: UtensilsCrossed, label: 'Staff Food Report', perm: 'employees', roles: ['admin', 'manager'], newSince: '2026-06-30' },
          { path: '/staff-performance', icon: Award, label: 'Staff Reliability', perm: 'employees', roles: ['admin', 'manager'] },
          { path: '/country-laws', icon: Globe, label: 'Labor Laws', perm: 'settings', roles: ['admin'] },
        ],
      },
      {
        label: 'Partners',
        items: [
          { path: '/partners', icon: Handshake, label: 'Partners', perm: 'partners', roles: ['admin'], featureFlag: 'enable_partner_entries' },
          { path: '/company-loans', icon: Building2, label: 'Company Loans', perm: 'partners', roles: ['admin'] },
        ],
      },
    ],
  },
  {
    label: 'Settings', module: 'admin',
    // iter930 — Everyday admin quick-links stay flat; specialised
    // Tax, POS, Data, Audit surfaces live in sub-folders.
    items: [
      { path: '/settings', icon: Settings, label: 'General Settings', perm: 'settings', roles: ['admin'] },
      { path: '/settings/company-profile', icon: Building2, label: 'Company Profile', perm: 'settings', roles: ['admin'] },
      { path: '/branches', icon: Store, label: 'Branches', perm: 'branches', roles: ['admin', 'manager'] },
      { path: '/users', icon: Shield, label: 'Users', perm: 'users', roles: ['admin'] },
      { path: '/branding', icon: Paintbrush, label: 'Branding & PDF', perm: 'settings', roles: ['admin'] },
      { path: '/help', icon: HelpCircle, label: 'Help & Guide' },
    ],
    subgroups: [
      {
        label: 'Company & Assets',
        items: [
          { path: '/assets', icon: Package, label: 'Assets & Liabilities', perm: 'branches', roles: ['admin', 'manager'] },
          { path: '/cctv', icon: Camera, label: 'CCTV Security', perm: 'branches', roles: ['admin', 'manager'] },
          { path: '/documents', icon: FileWarning, label: 'Documents', perm: 'documents', roles: ['admin', 'manager'] },
          { path: '/fleet', icon: Truck, label: 'Fleet', perm: 'settings', roles: ['admin', 'manager'] },
          { path: '/visitors', icon: UserIcon, label: 'Visitors', perm: 'settings', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Users & Access',
        items: [
          { path: '/role-management', icon: Shield, label: 'Roles & Permissions', roles: ['admin'] },
          { path: '/subscription', icon: CreditCard, label: 'Subscription', roles: ['admin'] },
          { path: '/super-admin', icon: Crown, label: 'Platform Admin', superAdmin: true },
        ],
      },
      {
        label: 'Compliance & Locks',
        items: [
          { path: '/fx-rates', icon: DollarSign, label: 'FX Rates', perm: 'reports', roles: ['admin'] },
          { path: '/settings/period-locks', icon: ShieldCheck, label: 'Period Locks', roles: ['admin', 'manager'], newSince: '2026-06-17' },
        ],
      },
      {
        label: 'POS & Hardware',
        items: [
          { path: '/pos-config', icon: Settings, label: 'POS Config', perm: 'settings', roles: ['admin'] },
          { path: '/settings/payment-terminals', icon: CreditCard, label: 'Payment Terminals', perm: 'settings', roles: ['admin', 'manager'], badge: 'New' },
          { path: '/settings/online-ordering', icon: QrCode, label: 'Online Ordering', perm: 'settings', roles: ['admin', 'manager'], newSince: '2026-07-19' },
          { path: '/printer-setup', icon: Printer, label: 'Printer Setup', roles: ['admin', 'manager'] },
          { path: '/settings/receipt', icon: Printer, label: 'Receipt Settings', roles: ['admin', 'manager'] },
          { path: '/pos-mapping', icon: Cpu, label: 'POS Mapping', roles: ['admin'] },
          { path: '/manage-hub', icon: Settings, label: 'Manage Hub', roles: ['admin', 'manager'] },
        ],
      },
      {
        label: 'Integrations & Data',
        items: [
          { path: '/integrations', icon: Key, label: 'API Keys', perm: 'settings', roles: ['admin'] },
          { path: '/modules', icon: Layers, label: 'Modules', perm: 'settings', roles: ['admin'] },
          { path: '/task-reminders', icon: Bell, label: 'Task Reminders', perm: 'settings', roles: ['admin'] },
          { path: '/notification-preferences', icon: Bell, label: 'Notification Settings' },
          { path: '/data-management', icon: Database, label: 'Data Management', perm: 'settings', roles: ['admin'] },
          { path: '/data-export', icon: Download, label: 'Data Export', perm: 'settings', roles: ['admin'] },
        ],
      },
      {
        label: 'Audit & Health',
        items: [
          { path: '/settings/audit-log', icon: Shield, label: 'Audit Log', roles: ['admin', 'manager', 'super_admin'], newSince: '2026-07-19' },
          { path: '/activity-logs', icon: Activity, label: 'Activity Logs', perm: 'settings', roles: ['admin'] },
          { path: '/erp-health-report', icon: Activity, label: 'ERP Health Report', roles: ['admin'] },
          { path: '/app-audit', icon: ShieldCheck, label: 'App Audit', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/daily-reconciliation', icon: Sparkles, label: 'Daily Reconciliation', perm: 'reports', roles: ['admin', 'manager'] },
          { path: '/route-health', icon: Activity, label: 'Route Health', roles: ['admin'] },
        ],
      },
      {
        label: 'Communications',
        items: [
          { path: '/announcements', icon: Megaphone, label: 'Announcements', perm: 'settings', roles: ['admin', 'manager'] },
          { path: '/surveys', icon: ClipboardList, label: 'Surveys', perm: 'settings', roles: ['admin', 'manager'] },
        ],
      },
    ],
  },
];

// Module-to-NavGroup mapping (iter931 — mapped to the granular layout)
export const MODULE_NAV_MAP = {
  accounting: ['Finance & Banking', 'VAT & Compliance'],
  hr: ['HR & Payroll'],
  pos: ['Operations and POS', 'Daily Operations'],
  reports: ['Finance & Banking', 'VAT & Compliance'],
  admin: ['Settings'],
  factory: ['Operations and POS'],
};

// Route-to-Module mapping
export const ROUTE_MODULE_MAP = {
  '/financial-dashboard': 'accounting', '/financial-ratios': 'accounting', '/chart-of-accounts': 'accounting', '/category-account-mapping': 'accounting',
  '/journal-entries': 'accounting', '/profit-loss': 'accounting', '/balance-sheet': 'accounting',
  '/trial-balance': 'accounting', '/cash-flow': 'accounting', '/general-ledger': 'accounting',
  '/aging-reports': 'accounting', '/pnl-compare': 'accounting', '/recurring-entries': 'accounting',
  '/smart-dunning': 'accounting', '/supplier-spent': 'accounting', '/ai-branch-loss': 'accounting',
  '/reversals-report': 'accounting',
  '/budget-vs-actual': 'accounting', '/auto-journal': 'accounting', '/bank-reconciliation': 'accounting',
  '/reconciliation-center': 'accounting',
  '/monthly-reconciliation': 'accounting',
  '/recon-inbox': 'accounting',
  '/year-end-closing': 'accounting', '/tax-settings': 'accounting', '/wht': 'accounting', '/fx-rates': 'accounting', '/tax-submissions': 'accounting', '/compliance': 'accounting', '/zatca-phase2': 'accounting', '/hmrc-mtd': 'accounting',
  '/account-statement': 'accounting', '/account-summary': 'accounting',
  '/accounting-reports': 'accounting',
  '/cost-center-report': 'accounting', '/sales-vat-report': 'accounting',
  '/purchases-vat-report': 'accounting', '/sales-summary-report': 'accounting',
  '/purchases-summary-report': 'accounting',
  '/invoices': 'accounting',
  '/proforma-invoices': 'accounting', '/debit-notes': 'accounting', '/credit-notes': 'accounting',
  '/customer-receipts': 'accounting', '/sales-transactions': 'accounting',
  '/bills': 'accounting', '/expenses': 'accounting',
  '/bill-returns': 'accounting', '/supplier-receipts-page': 'accounting', '/purchase-transactions': 'accounting',
  '/quotations': 'accounting', '/purchase-orders': 'accounting',
  '/employees': 'hr', '/attendance-dashboard': 'hr', '/payroll': 'hr', '/salary-report': 'hr', '/loans': 'hr',
  '/leave-approvals': 'hr', '/leave-calendar': 'hr', '/employee-documents': 'hr',
  '/performance-reviews': 'hr', '/training': 'hr', '/recruitment': 'hr',
  '/hr-analytics': 'hr', '/schedule': 'hr', '/staff-performance': 'hr', '/country-laws': 'hr', '/org-chart': 'hr',
  '/pos': 'pos', '/pos-analytics': 'pos', '/daily-summary': 'pos', '/sales': 'pos',
  '/platforms': 'pos', '/order-tracking': 'pos', '/customers': 'pos', '/loyalty': 'pos',
  '/stock': 'pos', '/stock-reorder': 'pos', '/inventory-forecast': 'pos', '/transfers': 'pos', '/recipes': 'pos', '/procurement': 'pos',
  '/menu-items': 'pos', '/addons': 'pos', '/menu-analytics': 'pos', '/table-management': 'pos',
  '/reservations': 'pos', '/salon-appointments': 'pos', '/weight-items': 'pos',
  '/meat-cuts': 'pos', '/tailoring-orders': 'pos', '/pharmacy-items': 'pos',
  '/bakery-production': 'pos', '/electronics-warranty': 'pos', '/pos-industry-dashboard': 'pos',
  '/kitchen': 'pos', '/pos-config': 'pos', '/suppliers': 'pos', '/supplier-payments': 'pos',
  '/cash-transfers': 'pos', '/supplier-aging': 'pos', '/supplier-reminders': 'pos',
  '/analytics': 'reports', '/advanced-analytics': 'reports', '/enhanced-pnl': 'reports', '/multi-branch-pnl-matrix': 'reports', '/inter-branch-ledger': 'reports',
  '/pass-through-advances': 'expenses',
  '/visualizations': 'reports', '/sales-forecast': 'reports', '/anomaly-detection': 'reports',
  '/bi-dashboard': 'reports', '/ai-hub': 'reports', '/cross-branch-report': 'reports',
  '/export-center': 'reports', '/data-integrity': 'reports', '/branch-cost-analyzer': 'reports',
  '/users': 'admin', '/settings': 'admin', '/settings/company-profile': 'admin', '/currency-settings': 'admin', '/branding': 'admin',
  '/scheduled-reports': 'admin', '/task-reminders': 'admin', '/task-compliance': 'admin',
  '/activity-logs': 'admin', '/audit-trail': 'admin', '/data-management': 'admin',
  '/data-export': 'admin', '/white-label': 'admin', '/usage-alerts': 'admin',
  '/rate-limits': 'admin', '/integrations': 'admin', '/modules': 'admin',
  '/role-management': 'admin', '/subscription': 'admin', '/super-admin': 'admin',
  '/analytics-dashboard': 'admin', '/lead-analytics': 'admin', '/branches': 'admin', '/assets': 'admin',
  '/cctv': 'admin', '/documents': 'admin', '/fines': 'admin', '/partners': 'admin', '/company-loans': 'admin',
  '/factory-dashboard': 'factory', '/production-orders': 'factory', '/bill-of-materials': 'factory',
  '/raw-materials': 'factory', '/machines': 'factory', '/quality-control': 'factory', '/factory-analytics': 'factory',
  '/announcements': 'admin', '/surveys': 'admin', '/visitors': 'admin', '/fleet': 'admin', '/budget': 'admin',
};

export const MODULE_COLORS = {
  accounting: 'from-blue-600 to-indigo-700',
  hr: 'from-emerald-600 to-teal-700',
  pos: 'from-amber-500 to-orange-600',
  reports: 'from-violet-600 to-purple-700',
  admin: 'from-stone-700 to-stone-900',
  factory: 'from-cyan-600 to-blue-700',
};

export const MODULE_LABELS = {
  accounting: 'Accounting',
  hr: 'HR & Workforce',
  pos: 'POS & Sales',
  reports: 'Reports & Analytics',
  admin: 'Administration',
  factory: 'Factory',
};

// Normalize permissions - support both old list format and new dict format
export function normalizePermissions(perms) {
  if (Array.isArray(perms)) {
    const dict = {};
    perms.forEach(p => { dict[p] = 'write'; });
    return dict;
  }
  if (typeof perms === 'object' && perms !== null) {
    return perms;
  }
  return {};
}

// Permission-to-module mapping (same as backend MODULE_MAP)
const PERM_MODULE_MAP = {
  sales: 'sales', expenses: 'expenses', stock: 'stock',
  invoices: 'sales', suppliers: 'stock', customers: 'sales',
  employees: 'hr', reports: 'reports', settings: 'admin',
  partners: 'finance', documents: 'admin', branches: 'admin',
  transfers: 'stock', credit_report: 'reports', supplier_report: 'reports',
  schedule: 'hr', leave: 'hr', fines: 'hr', loans: 'hr',
  users: 'admin', kitchen: 'pos', shifts: 'hr', accounting: 'accounting',
  supplier_payments: 'expenses', cash_transfers: 'pos',
  dashboard: 'pos', factory: 'factory',
};

// Check if user has permission (at least read access)
// For managers: if the permission's module is in allowedModules, grant implicit read
export function hasPermission(perms, module, userRole, allowedModules) {
  const normalizedPerms = normalizePermissions(perms);
  const level = normalizedPerms[module];
  if (level === 'read' || level === 'write') return true;

  // Managers get implicit read access to modules in their allowedModules
  if (userRole === 'manager' && allowedModules && allowedModules.length > 0) {
    const mapped = PERM_MODULE_MAP[module] || module;
    if (allowedModules.includes(mapped)) return true;
  }

  return false;
}

// Employee nav items
export const EMPLOYEE_NAV = [
  { path: '/my-portal', icon: UserIcon, label: 'My Portal' },
  { path: '/notifications', icon: Bell, label: 'Notifications' },
];

// Keyboard shortcuts mapping
export const KEYBOARD_SHORTCUTS = {
  'd': '/', 'n': '/pos', 'p': '/pos', 's': '/sales', 'e': '/expenses',
  'i': '/stock', 'r': '/reports', 'a': '/analytics', 'v': '/visualizations',
  't': '/table-management', 'l': '/loans', 'w': '/waiter', 'c': '/cashier',
  'k': '/kds', 'h': '/employees', 'o': '/order-status', 'b': '/reconciliation',
  'f': '/performance-report', 'g': '/task-compliance', 'j': '/invoices',
  'm': '/menu-items', 'q': '/schedule',
  '?': 'shortcuts',
};

// Bottom nav default items
export const DEFAULT_BOTTOM_NAV = [
  { path: '/', icon: 'LayoutDashboard', label: 'Home', enabled: true },
  { path: '/sales', icon: 'ShoppingCart', label: 'Sales', enabled: true },
  { path: '/expenses', icon: 'Receipt', label: 'Expenses', enabled: true },
  { path: '/stock', icon: 'Package', label: 'Stock', enabled: true },
  { path: '/reports', icon: 'BarChart3', label: 'Reports', enabled: true },
];

// Bottom nav customization options
export const BOTTOM_NAV_OPTIONS = [
  { path: '/', icon: 'LayoutDashboard', label: 'Home' },
  { path: '/sales', icon: 'ShoppingCart', label: 'Sales' },
  { path: '/expenses', icon: 'Receipt', label: 'Expenses' },
  { path: '/stock', icon: 'Package', label: 'Stock' },
  { path: '/reports', icon: 'BarChart3', label: 'Reports' },
  { path: '/customers', icon: 'Users', label: 'Customers' },
  { path: '/employees', icon: 'Users', label: 'Employees' },
  { path: '/branches', icon: 'Store', label: 'Branches' },
  { path: '/analytics', icon: 'BarChart3', label: 'Analytics' },
  { path: '/cctv', icon: 'Camera', label: 'CCTV' },
  { path: '/credit-report', icon: 'CreditCard', label: 'Credits' },
  { path: '/settings', icon: 'Settings', label: 'Settings' },
];

// Icon map for bottom nav (string name -> component)
export const BOTTOM_NAV_ICON_MAP = {
  LayoutDashboard, ShoppingCart, Receipt, Package, BarChart3,
  Users, Settings, Store, CreditCard, FileText, Camera,
};

// Path permission map for bottom nav
export const BOTTOM_NAV_PERMS = {
  '/': 'dashboard', '/sales': 'sales', '/expenses': 'expenses',
  '/stock': 'stock', '/reports': 'dashboard', '/customers': 'customers',
  '/employees': 'employees', '/analytics': 'dashboard',
};
